export enum ActionType {
    NOTI__EC__RELOAD = 'NOTI__EC__RELOAD',
    NOTI__EC__RELOAD_RESULT = 'NOTI__EC__RELOAD_RESULT',
    NOTI__EC__SELECT_CATEGORY = 'NOTI__EC__SELECT_CATEGORY',
    NOTI__EC__TOGGLE_SEARCH = 'NOTI__EC__TOGGLE_SEARCH',
    NOTI__EC__FILTER_ITEMS = 'NOTI__EC__FILTER_ITEMS',
    NOTI__EC__FILTER_ITEMS_RESULT = 'NOTI__EC__FILTER_ITEMS_RESULT',
    NOTI__EC__RECEIVE_ITEMS = 'NOTI__EC__RECEIVE_ITEMS',
    NOTI__EC__TOGGLE_ITEM_EXPAND = 'NOTI__EC__TOGGLE_ITEM_EXPAND',
    NOTI__EC__UPDATE_ITEMS = 'NOTI__EC__UPDATE_ITEMS',
    NOTI__EC__UPDATE_ITEMS_RESULT = 'NOTI__EC__UPDATE_ITEMS_RESULT',
    NOTI__EC__SORT_ITEMS = 'NOTI__EC__SORT_ITEMS',
    NOTI__EC__SEE_ITEMS = 'NOTI__EC__SEE_ITEMS',
    NOTI__EC__RESET = 'NOTI__EC__RESET',
    NOTI__EC__UPDATE_CATEGORY_ACTION = 'NOTI__EC__UPDATE_CATEGORY_ACTION',
}
